import type {HTTPQuery, ConfigurationParameters} from '@linx-security/api-specs';
import qs from 'qs';

import {isSortingState, transformSort} from './sort';

/**
 * TODO:
 *  1. Write actual logic
 *  2. Add unit testing
 */
export const queryParamsStringify: ConfigurationParameters['queryParamsStringify'] = (params: HTTPQuery) => {
  if (!params) return ``;
  const clone = {...params};

  if (typeof clone.filters === `object`) {
    clone.filters = JSON.stringify(params.filters);
  }

  if (typeof clone.traversal_filters === `object`) {
    clone.traversal_filters = JSON.stringify(params.traversal_filters);
  }

  if (isSortingState(params.sort)) {
    clone.sort = transformSort(params.sort);
  }

  const query = qs.stringify(clone, {skipNulls: true, arrayFormat: `comma`});

  return query;
};
